import * as React from "react";
import {
    InputAdornment,
    TextField,
    StyleRulesCallback,
    withStyles,
    WithStyles,
    Typography
} from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";
import Colors from "../../assets/Colors";
import { InputBaseComponentProps } from "@material-ui/core/InputBase";
import Icon from "../Icon/Icon";

export enum SLTextFieldType {
    Text,
    Dollar,
    Select
}

interface IProps {
    className?: string;
    isShortInput?: boolean;
    slType?: SLTextFieldType;
    isDefaultSelection?: boolean;
    errorText?: string;
    label?: string;
    textFieldProps?: TextFieldProps;
    onChange?: (value: string) => void;
    inputComponent?: React.ReactType<InputBaseComponentProps>;
    isErrorOnSameLine?: boolean
}

const styles: StyleRulesCallback = ({ palette, breakpoints }) => ({
    container: {
    },
    root: {
        width: "93%",
        border: 0,
        borderRadius: 10,
        padding: ".2em .8em",
        fontSize: 15,
        background: "#FFFFFF",
        boxShadow: "0 2px 4px 0 rgba(226, 230, 236, 0.5)",
        marginTop: ".55em",
        borderBottom: "2px solid transparent",
        "&:focus-within": {
            borderBottom: "2px solid #305cc6"
            },
            [breakpoints.down("sm")]: {
                width: "88%",
                fontSize: 15,
            }
    },
    short: {
      width: "3em"
    },
    inputRoot: {
        marginTop: "6px !important",
        fontSize: "15px!important",
    },
    inputInputRoot: {
        fontSize: 15,
        color: "2f3033!important",
        padding: 0,
        "&::placeholder": {
            color: "#9CA6AD",
            opacity: 1
        },
        [breakpoints.down("sm")]: {
            fontSize: 15,
            marginTop: ".3em"
        }
    },
    label: {
        flex: 1,
        fontSize: 14,
        fontWeight: 400,
        color: "#2F3033",
        width: "140%",
        display: "flex",
        flexDirection: "column",
        [breakpoints.down("sm")]: {
            flex: 0,
            width: "230%",
            fontWeight: 400,
            marginBottom: 0
        }
    },
    labelError: {
        color: palette.error.main,
    },
    space: {
        height: 20,
        width: "100%",
        clear: "both"
    },
    inputAdornment: {
        marginRight: 2
    },
    inputAdornmentText: {
        fontSize: 16,
        color: palette.text.hint,
        fontWeight: "bold"
    },
    bottomArrow: {
        width: 10,
        height: 4,
        marginTop: 6
    },
    iconContainer: {
        paddingLeft: ".7em",
        borderLeft: "1px solid #E1E6EA",
            [breakpoints.down("sm")]: {
                height: "1em",
                display: "flex",
                alignItems: "center",
                justifyContent:"center",
                flexDirection: "column"
        }
    }
});

@(withStyles(styles) as any)
export default class SLTextFieldNew extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {
    public render() {
        const { classes, label, errorText, className, isErrorOnSameLine } = this.props;
        return (
            <div className={[classes!.container, className].join(" ")}>
                <div className={classes!.label}>
                    {label}
                    {errorText? <span className={classes!.labelError}>{errorText}</span>: null}
                    {isErrorOnSameLine? <div className={classes!.space} /> : null}
                </div>
                {this.renderTextField()}
            </div>
        );
    }

    private renderTextField() {
        const {
            classes,
            slType,
            isDefaultSelection,
            textFieldProps,
            inputComponent,
            isShortInput
        } = this.props;
        let classesName = textFieldProps ? textFieldProps.className : "";
        classesName += isShortInput? " " + classes!.short: "";
        return (
            <TextField
                className={`${classes!.root} ${classesName}`}
                InputLabelProps={{
                    shrink: true,
                    className: classes!.labelShrink
                }}
                inputProps={{
                    style: {
                        cursor: slType === SLTextFieldType.Select ? "pointer" : "",
                        color: isDefaultSelection ? Colors.hint : "",
                    }

                    // height: 60%;
                    // margin: auto -2px;
                    // padding-left: .6em;

                }}
                InputProps={{
                    className: classes!.inputRoot,
                    ...({ disableUnderline: true } as any), // TS issue
                    startAdornment: this.inputStartAdornment(),
                    endAdornment: this.inputEndAdornment(),
                    inputComponent: inputComponent as any
                }}
                onChange={this.onChange}
                {...textFieldProps}
                value={(textFieldProps && textFieldProps.value) || ""}
            />
        );
    }

    private inputStartAdornment() {
        const { slType, classes } = this.props;
        switch (slType) {
            case SLTextFieldType.Dollar: {
                return (
                    <InputAdornment className={classes!.inputAdornment} position="start">
                        <Typography className={classes!.inputAdornmentText}>$</Typography>
                    </InputAdornment>
                );
            }
            default:
                return null;
        }
    }

    private inputEndAdornment() {
        const { slType, classes} = this.props;
        switch (slType) {
            case SLTextFieldType.Select: {
                return (
                    <div className={classes!.iconContainer}>
                        <Icon icon={'blueArrowDown'}/>
                    </div>
                );
            }
            default:
                return null;
        }
    }

    private onChange = (event: any) => {
        const { onChange } = this.props;
        if (onChange) {
            onChange(event.target.value);
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/Input/SLTextFieldNew.tsx